// extracted by mini-css-extract-plugin
module.exports = {"root":"IconPool_root__3OtI6"};